import { crudSelectorsCustom } from 'redux/crudCreatorCustom/selector';
import { MODEL_NAME } from './actions';

export const unownedCompaniesOfUserSelectors = crudSelectorsCustom(MODEL_NAME);
